import { runWithRenderSlice } from "@otto-ec/global-resources/core";
import { track } from "../../../../common/utils/track";
import { isFirstChildAnchor } from "./utils";

export const useOverflowCalc = (Host: HTMLOcButtonV1Element) => {
  let isSpanOverflowingAbortController: AbortController;

  const state = $state({
    innerSpan: undefined as HTMLElement | undefined,
    innerSpanClientWidth: 0,

    isOverflowing: false,
  });

  /*                                                                */
  /*                                                                                                   */
  /*                                  */
  $effect(() => {
    /*                                                      */
    isSpanOverflowingAbortController?.abort();
    isSpanOverflowingAbortController = new AbortController();

    /*                                             */
    track(state.innerSpanClientWidth, state.innerSpan);

    /*                                */
    runWithRenderSlice(
      () => {
        const isSpanOverflowing = !!(
          state.innerSpan && state.innerSpan?.scrollWidth > state.innerSpanClientWidth
        );

        const isAnchorOverflowing =
          isFirstChildAnchor(Host.children[0]) &&
          Host.children[0].scrollWidth > state.innerSpanClientWidth;

        state.isOverflowing = isSpanOverflowing || isAnchorOverflowing;
      },
      { signal: isSpanOverflowingAbortController.signal, silent: true },
    );
  });

  return state;
};
